import { ReactNode } from 'react';
import { ROLE_LABEL, StaffRole } from '../../auth/roles';

export function Badge({ children, tone, dot }: { children: ReactNode; tone?: 'good' | 'critical' | 'warning'; dot?: boolean }) {
  return <span className={`badge ${tone ?? ''} ${dot ? 'dot' : ''}`}>{children}</span>;
}

export function RoleBadge({ role }: { role: StaffRole }) {
  return <span className={`badge role-${role}`}>{ROLE_LABEL[role]}</span>;
}

/** Status always pairs a dot + label with its color, never color alone. */
export function StatusBadge({ status: raw }: { status: string }) {
  // GraphQL enums arrive by name (HIDDEN); plain strings arrive lowercase
  const status = raw.toLowerCase();
  const tone = status === 'active' ? 'good' : status === 'blocked' || status === 'removed' ? 'critical' : status === 'hidden' || status === 'open' ? 'warning' : undefined;
  return (
    <Badge tone={tone} dot>
      {status}
    </Badge>
  );
}
